import { Button, Grid, styled, Typography } from '@mui/material'
import * as colors from 'utils/color'

export const LogoContainer = styled(Grid)(() => ({
  width: '100%',
  minHeight: '100%',
}))

export const LandingText = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(3),
}))

export const LandingButton = styled(Button)(() => ({
  width: 200,
  height: 50,
  backgroundColor: colors.red,
  color: colors.white,
  fontWeight: 'bold',
}))
